<template>
  <LoadingBlock />
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import { useJwt } from '@vueuse/integrations/useJwt'
import { unref,watch } from "vue";
import { useRouter } from "vue-router";

import LoadingBlock from "@/components/LoadingBlock.vue";
import { useAuthStore } from "@/stores/auth";

const { user, getAccessTokenSilently } = useAuth0()

const authStore = useAuthStore()
const router = useRouter();

watch(user, async (to, from) => {
  if (to) {
    const jwt = await getAccessTokenSilently();
    const { payload } = useJwt(jwt)
    authStore.user = user.value
    authStore.payload = unref(payload)
    Sentry.setUser({ email: user.value.email });

    router.replace({ path: '/dashboard' })
  }
  
})

</script>